import React from 'react';
import PropTypes from 'prop-types';
import Header from '../../components/Header';
import Tabbar from '../../components/Tabbar';

const Layout = ({ children }) => (
  <>
    <Header />
    <Tabbar />
    {children}
  </>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
